export const RealEstateData = [
  {
    title: "Photo Enhancement",
    desc: "We can quickly enhance interior and exterior images by adjusting brightness, contrast, sharpness, white balance, along ith other parameters to give photos a better overall look. You can also order batch real estate image editing at a discount.",
    para1: "Color enhancing:",
    para2: "White Balance fixing:",
    para3: "Window view replacement",
    para4: "Shadows removal",
    para5: "Several objects removal",
    para6: "Ceiling cleaning",
  },

  {
    title: "HDR Real Estate Photo Editing",
    desc: "Your exterior photos look as dull as this “before” photo? Address us and we can make your property images bright, saturated, full of colors and shadows. Real estate photos look better in HDR that is good for displaying maximum details.",
    heading: "Real estate photo editing includes:",
    para1: "Vertical and horizontal strengthening",
    para2: "Color correction",
    para3: "Sky color enhancement",
    para4: "Lawn generation",
    para5: "Getting rid of sun glare",
  },
  {
    title: "Standard Real Estate Photo Editing",
    desc: "Artificial lighting, gloomy weather outside, shadows from various items, incorrect camera settings, and other factors can affect the color of the property. Order our real estate photo editing services and we’ll make lights, shadows and colors eye-pleasing and true-to-life.",
    heading: "Services applied:",
    para1: "LR adjustments",
    para2: "Wall/floor cleaning",
    para3: "Sharpening",
  },
  {
    title: "Trustworthy Real Estate Editing Outsourcing",
    desc: "Sell your property faster addressing https://captureedits.com/ real estate photo editing services. We will remove flashes and adjust lighting, get rid of small items and improve colors to make your images look great.",
    heading: "Services applied:",

    para1: "Color correction",
    para2: " Contrast and light adjustment",
    para3: "Reflections removal",
    para4: " Clean the metal of the hood",
    para5: " Softening of falling shadows",
    para6: "Removing overexposure on furniture",
    para7: "Making light sources bright",
  },
 
];
